import config from '../../config'
import {
  getNotifyTypeTranslate,
  getRecipientTypeTranslate,
  getSubjectTypeTranslate,
} from '../../helpers/scheduled-notification-helper'
import translate from '../../i18n'
import { PageInfo } from '../../share-types'
import {
  IScheduledNotification,
  ScheduledNotificationPriorityEnums,
  ScheduledNotificationStatusEnums,
  ScheduledNotificationTypeEnums,
} from './share-type'
import { Button, Space, Table, Tag } from 'antd'
import { ColumnsType } from 'antd/es/table'
import Title from 'antd/es/typography/Title'
import { type PresetColorType } from 'antd/lib/_util/colors'

interface ScheduledNotificationsTableProps {
  data: IScheduledNotification[]
  pageInfo?: PageInfo
  paginationOnChange: (page: number, pageSize: number) => void
}

const { guavapassUrl } = config

const ScheduledNotificationsTable = (props: ScheduledNotificationsTableProps) => {
  const { data, pageInfo, paginationOnChange } = props

  const columns: ColumnsType<IScheduledNotification> = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      width: 60,
      render: (id: number) => {
        return (
          <Button
            type="link"
            target="_blank"
            href={`${guavapassUrl}/admin/scheduled_notifications/${id}`}
          >
            {id}
          </Button>
        )
      },
    },
    {
      title: translate('scheduledNotification.subject'),
      dataIndex: 'subjectId',
      key: 'subjectId',
      render: (subjectId: number, record: IScheduledNotification) => {
        return `${getSubjectTypeTranslate(record.subjectType)}:${subjectId}`
      },
    },
    {
      title: translate('scheduledNotification.recipient'),
      dataIndex: 'recipientId',
      key: 'recipientId',
      render: (recipientId: number, record: IScheduledNotification) => {
        return `${getRecipientTypeTranslate(record.recipientType)}:${recipientId}`
      },
    },
    {
      title: translate('scheduledNotification.notifyType'),
      dataIndex: 'notifyType',
      key: 'notifyType',
      render: (notifyType: ScheduledNotificationTypeEnums) => {
        return getNotifyTypeTranslate(notifyType)
      },
    },
    {
      title: translate('scheduledNotification.sendTimeWindowStart'),
      dataIndex: 'sendTimeWindowStart',
      key: 'sendTimeWindowStart',
    },
    {
      title: translate('scheduledNotification.SendTimeWindowEnd'),
      dataIndex: 'sendTimeWindowEnd',
      key: 'sendTimeWindowEnd',
    },
    {
      title: translate('scheduledNotification.priority'),
      dataIndex: 'priority',
      key: 'priority',
      render: (priority: ScheduledNotificationPriorityEnums) => {
        let color: PresetColorType
        switch (priority) {
          case ScheduledNotificationPriorityEnums.LOW:
            color = 'cyan'
            break
          case ScheduledNotificationPriorityEnums.MIDDLE:
            color = 'orange'
            break
          case ScheduledNotificationPriorityEnums.HIGH:
            color = 'red'
            break
        }
        return <Tag color={color}>{priority}</Tag>
      },
    },
    {
      title: translate('status'),
      dataIndex: 'status',
      key: 'status',
      render: (status: ScheduledNotificationStatusEnums) => {
        let color: PresetColorType | undefined = undefined
        switch (status) {
          case ScheduledNotificationStatusEnums.SUCCESS:
            color = 'green'
            break
          case ScheduledNotificationStatusEnums.FAILED:
            color = 'red'
            break
        }
        return <Tag color={color}>{status}</Tag>
      },
    },
    {
      title: translate('createdAt'),
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: translate('updatedAt'),
      dataIndex: 'updatedAt',
      key: 'updatedAt',
    },
  ]

  return (
    <Space className="table-space" orientation="vertical" size={16}>
      <Title level={5}>{translate('scheduledNotification.listTitle')}</Title>

      <Table
        rowKey={record => record.id}
        columns={columns}
        dataSource={data}
        pagination={{
          current: pageInfo?.currentPage,
          pageSize: pageInfo?.pageSize,
          total: pageInfo?.count,
          onChange: paginationOnChange,
        }}
      />
    </Space>
  )
}

export default ScheduledNotificationsTable
